import { render, staticRenderFns } from "./prihodDialog.vue?vue&type=template&id=5b91162f&scoped=true&"
import script from "./prihodDialog.vue?vue&type=script&lang=js&"
export * from "./prihodDialog.vue?vue&type=script&lang=js&"
import style0 from "./prihodDialog.vue?vue&type=style&index=0&id=5b91162f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91162f",
  null
  
)

export default component.exports